import { render, staticRenderFns } from "./UserActivity.vue?vue&type=template&id=a7766038&scoped=true"
import script from "./UserActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./UserActivity.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserActivity.vue?vue&type=style&index=0&id=a7766038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7766038",
  null
  
)

export default component.exports